import type { ReactNode } from 'react';
import { ConstellationBackground } from '@/components/animations/constellation-background';

interface PageContainerProps {
  children: ReactNode;
  showConstellation?: boolean;
  transparent?: boolean;
  className?: string;
  /** false when a PageHero sits above (the hero carries the top spacing) */
  padTop?: boolean;
}

export function PageContainer({
  children,
  showConstellation = true,
  transparent = false,
  className = '',
  padTop = true,
}: PageContainerProps) {
  return (
    <div
      className={`relative flex-1 overflow-hidden ${transparent ? 'bg-transparent' : 'bg-slate-950'}`}
    >
      {showConstellation && <ConstellationBackground />}
      <div
        className={`container relative mx-auto px-4 ${padTop ? 'pt-16' : 'pt-10 md:pt-14'} pb-8 z-10 ${className}`}
      >
        {children}
      </div>
    </div>
  );
}
